import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CardBrandIconPipe } from './cardBrandIcon.pipe';
import { PhonePipe } from './phone.pipe';
import { CpfCnpjPipe } from './cpfCnpj.pipe';
import { FormatTimePipe } from './formatTime.pipe';
import { MultiCurrencyPipe } from './multiCurrency.pipe';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { manualTranslate } from './manualTranslate.pipe';
import { ToDateObjPipe } from './toDateObj.pipe';
import { GeocodeToAddress } from './geocodeToAddress.pipe';
import { FractionPipe } from './fraction.pipe';

@NgModule({
    imports: [IonicModule],
    declarations: [
        CardBrandIconPipe,
        PhonePipe,
        MultiCurrencyPipe,
        manualTranslate,
        CpfCnpjPipe,
        FormatTimePipe,
        ToDateObjPipe,
        FractionPipe,
    ],
    exports: [
        CardBrandIconPipe,
        PhonePipe,
        MultiCurrencyPipe,
        manualTranslate,
        CpfCnpjPipe,
        FormatTimePipe,
        ToDateObjPipe,
        FractionPipe,
    ],
    providers: [
        CurrencyPipe,
        MultiCurrencyPipe,
        manualTranslate,
        TranslatePipe,
        GeocodeToAddress,
        FormatTimePipe,
        DatePipe,
        FractionPipe,
    ],
})
export class PipesModule {}
